/**
 * Cloudflare Turnstile **site key** — publishable by design (it ships in the
 * page markup), so it lives in code rather than in the secret store.
 *
 * Leave empty to disable the bot check entirely: every auth flow then falls
 * back to the server-side rate limiter, with no visible security-check UI.
 * The server secret (`TURNSTILE_SECRET_KEY`) is stored separately.
 */
export const TURNSTILE_SITE_KEY_FALLBACK = "0x4AAAAAAEPXu7LvAFufbnPY";
